module.exports = __webpack_public_path__ + "img/addprofile.f615accc.svg";